import casinoApi from 'api/casinoApi';
import { useHandleResponseError } from 'hooks/useHandleResponseError';
import useUserDetail from 'hooks/useUserDetail';
import { AwcGame } from 'models/casino';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { MdRefresh } from 'react-icons/md';
import { IoIosArrowRoundBack } from 'react-icons/io';
import ConditionButton from 'components/Commons/ConditionButton';
export interface HomeCasinoItemProps {
  game: AwcGame;
  handleRetry?: () => void;
  gameImage?: string;
  handleClose?: () => void;
}

const HomeCasinoItem: React.FC<HomeCasinoItemProps> = ({
  game,
  handleRetry,
  gameImage,
  handleClose,
}) => {
  const { isUserLoggedIn } = useUserDetail();
  const handleResponseError = useHandleResponseError();

  const playGame = async () => {
    const { ok, body, error } = await casinoApi.playGame({
      gameCode: game.gameCode,
      mobileLogin: false,
      provider: game.provider,
    });

    if (ok && body) {
      window.open(body.url, '_blank');
    }
    if (error) {
      handleResponseError(error);
    }
  };
  return (
    <ConditionButton
      className="play-button"
      onClick={playGame}
      content={
        <div key={game.gameCode} className="home-casino-game-item">
          <img
            onError={(e) => {
              e.currentTarget.src = '/no_image.png';
            }}
            src={gameImage ? gameImage : game.image}
            alt="preview"
          />
        </div>
      }
      testerCheck={true}
    />
  );
};

export default HomeCasinoItem;

export interface IframeGameProps {
  title: string;
  gameUrl: string;
  gameCode: string;
  provider: string;
  handleRetry?: () => void;
  handleClose?: () => void;
}

export const IframeGame: React.FC<IframeGameProps> = ({
  title,
  gameUrl,
  handleRetry,
  handleClose,
}) => {
  const handleResponseError = useHandleResponseError();
  return (
    <div className="casino-iframe-container">
      {handleRetry && (
        <button className="retry-button" onClick={handleRetry}>
          <MdRefresh size={20} />
        </button>
      )}

      {handleClose && (
        <button className="close-button" onClick={handleClose}>
          <IoIosArrowRoundBack size={20} />
        </button>
      )}
      <iframe sandbox="allow-scripts allow-same-origin" src={gameUrl} title={title} />
    </div>
  );
};
